export const FETCH_PROJECT_TEMPLATE_SUB_TASK_BYID_REQUEST = 'FETCH_PROJECT_TEMPLATE_SUB_TASK_BYID_REQUEST'
export const FETCH_PROJECT_TEMPLATE_SUB_TASK_BYID_SUCCESS = 'FETCH_PROJECT_TEMPLATE_SUB_TASK_BYID_SUCCESS'
export const FETCH_PROJECT_TEMPLATE_SUB_TASK_BYID_FALUIRE = 'FETCH_PROJECT_TEMPLATE_SUB_TASK_BYID_FALUIRE'
